import { object } from 'valibot';

import { PasswordSchema } from './PasswordSchema';

export const ResetPasswordSchema = () =>
  object({
    password: PasswordSchema(),
    confirmPassword: PasswordSchema()
  });
